import { type ITimeSlot } from './time-slot.js';

export enum TimeSlotOverlap {
  /** TimeSlot starts before referenced TimeSlot and ends during referenced TimeSlot */
  ONLY_START = 'ONLY_START',
  /** TimeSlot start during reference TimeSlot and ends after referenced TimeSlot */
  ONLY_END = 'ONLY_END',
  /** Timeslot starts before and ends after referenced TimeSlot */
  COMPLETE = 'COMPLETE',
  /** TimeSlot starts and end during referenced TimeSlot */
  INSIDE = 'INSIDE',
  /** TimeSlot is exactly overlapping with reference TimeSlot */
  MATCHING = 'MATCHING',
  /** TimeSlot has no overlap with referenced TimeSlot */
  NONE = 'NONE',
}

// eslint-disable-next-line complexity
export const isTimeSlotOverlapping = (testTimeSlot: ITimeSlot, referenceTimeSlot: ITimeSlot) => {
  // ignore non blocking slots
  if (testTimeSlot.isNonBlocking || referenceTimeSlot.isNonBlocking) return TimeSlotOverlap.NONE;

  // test time slot completely overlaps reference time slot
  if (testTimeSlot.start < referenceTimeSlot.start && testTimeSlot.end > referenceTimeSlot.end)
    return TimeSlotOverlap.COMPLETE;

  // test time slot overlaps at beginning
  if (testTimeSlot.start < referenceTimeSlot.start && testTimeSlot.end > referenceTimeSlot.start)
    return TimeSlotOverlap.ONLY_START;

  // test time slot overlaps at the end
  if (testTimeSlot.start < referenceTimeSlot.end && testTimeSlot.end > referenceTimeSlot.end)
    return TimeSlotOverlap.ONLY_END;

  // test time slot is inside of timeslot
  if (testTimeSlot.start >= referenceTimeSlot.start && testTimeSlot.end <= referenceTimeSlot.end)
    return TimeSlotOverlap.INSIDE;

  // test time slot exaclty matches timeslot
  if (testTimeSlot.start >= referenceTimeSlot.start && testTimeSlot.end <= referenceTimeSlot.end)
    return TimeSlotOverlap.MATCHING;

  // test time slot does not touch timeslot
  return TimeSlotOverlap.NONE;
};

export const isTimeSlotOverlappingWithList = (testTimeSlot: ITimeSlot, referenceTimeSlots: ITimeSlot[]) => {
  for (const t2 of referenceTimeSlots) {
    if (isTimeSlotOverlapping(testTimeSlot, t2) !== TimeSlotOverlap.NONE) return true;
  }
  return false;
};

export const areTimeSlotOverlapping = (timeSlots: ITimeSlot[]) => {
  for (let i = 0; i < timeSlots.length; i++) {
    const t1 = timeSlots[i];
    const otherTimeslots = timeSlots.filter((_, j) => i !== j);
    if (isTimeSlotOverlappingWithList(t1!, otherTimeslots)) return true;
  }

  return false;
};
